document.addEventListener("DOMContentLoaded", function() {
    let els = document.querySelectorAll('.elem');
    els.forEach(function(fadeIn) {
        function fadeOnScroll() {
            const windowHeight = window.innerHeight;
            const offset = fadeIn.getBoundingClientRect().top;
            const scroll = window.scrollY;
            if (offset < windowHeight && offset > -fadeIn.offsetHeight) {
                fadeIn.classList.add('is_show');
                window.removeEventListener('scroll', fadeOnScroll);
            }
        }
        window.addEventListener('scroll', fadeOnScroll);
    });
});


window.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

    anchorLinksArr.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const targetId = link.hash;
            const targetElement = document.querySelector(targetId);
            const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
            window.scrollTo({
                top: targetOffsetTop,
                behavior: "smooth"
            });
        });
    });
});

// For FAQ
function toggleAnswer(label) {
    label.classList.toggle('active');
}